import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';

export default function isEmailProper(string) {
  const trimmedString = string.trim();
  return /@[a-zA-Z0-9.-]*$/.test(trimmedString) && isEmail(trimmedString, {
    allow_utf8_local_part: false,
  }) && !isEmpty(trimmedString);
}
